import React, { Component } from "react";
import cx from "classnames";
import { get, isEmpty } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";
import "./AccountHistory.scss";
import DateHelper from "utils/date";
import { money } from "utils/currencyHelper";

const ccn = getClassName("account-history");

class AccountHistory extends Component {
  static defaultProps = {
    data: []
  };

  render() {
    const { data } = this.props;

    if (isEmpty(data)) return null;

    return (
      <div className={ccn()}>
        <h2 className={ccn("title")}>
          <FormattedMessage
            id="hbc.dashboard.account.history"
            defaultMessage="account history"
          />
        </h2>
        <div className={ccn("table")}>
          <div className={cx(ccn("table-row"), ccn("table-row_header"))}>
            <div className={cx(ccn("table-column"), ccn("table-column_date"))}>
              <FormattedMessage id="hbc.dashboard.account.history.date" defaultMessage="Date" />
            </div>
            <div className={cx(ccn("table-column"), ccn("table-column_balance"))}>
              <FormattedMessage id="hbc.dashboard.account.history.balance" defaultMessage="Balance" />
            </div>
            <div className={cx(ccn("table-column"), ccn("table-column_gain-loss"))}>
              <FormattedMessage id="hbc.dashboard.account.history.gain.loss" defaultMessage="Gain/Loss" />
            </div>
            <div className={cx(ccn("table-column"), ccn("table-column_fee"))}>
              <FormattedMessage id="hbc.dashboard.account.history.fee" defaultMessage="Fee" />
            </div>
          </div>
          {data.map((item) => {
            const gainLoss = parseFloat(item.gainLoss);
            return (
              <div className={ccn("table-row")} key={item.createdAt}>
                <div className={cx(ccn("table-column"), ccn("table-column_date"))}>
                  {new DateHelper(item.createdAt).format("mm/dd/yyyy")}
                </div>

                <div className={cx(ccn("table-column"), ccn("table-column_balance"))}>
                  <div>{item.balance ? `$${item.balance}` : ""}</div>
                  <div className={ccn("table-column_balance-date")}>
                    {new DateHelper(item.createdAt).format("mm/dd/yyyy")}
                  </div>
                </div>

                <div className={ccn(`table-column${gainLoss < 0 ? " negative" : ""}`)}>
                  {gainLoss === 0
                    ? `${money(item.gainLoss, "en", { currency: "USD" })}`
                    : `${item.gainLoss < 0 ? "-" : ""}$${Math.abs(gainLoss)}`
                  }
                </div>

                <div className={ccn("table-column")}>
                  {parseFloat(get(item, "fee.amount", "0")) > 0 && `$${item.fee.amount}`}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default injectIntl(AccountHistory);



// WEBPACK FOOTER //
// ./src/containers/dashboard/accountHistory/AccountHistory.js